import * as React from "react";
import { InputLayout } from "../../../components/planMaking/resultsInput";
import { PlansInputEstimatedInThisTermFieldCalc } from "../../../types/plansInputEstimatedInTHisTermFIeldsCalc";
import {
  CostPlansInputEstimatedInThisTermTable,
  PlPlansInputEstimatedInThisTermTable,
} from "../PlansInputEstimatedInThisTerm";

interface Props {
  url: string;
  calcState: PlansInputEstimatedInThisTermFieldCalc;
}

export const PlansInputEstimatedInThisTermContainer: React.FC<Props> = ({
  url,
  calcState,
}) => {
  return (
    <InputLayout>
      {/* PL */}
      <div id="pl"></div>
      <PlPlansInputEstimatedInThisTermTable calcState={calcState} url={url} />

      {/* 原価 */}
      <div className="mt-50px" id="cost"></div>
      <CostPlansInputEstimatedInThisTermTable calcState={calcState} url={url} />
    </InputLayout>
  );
};
